import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { get, post } from 'helpers/requests';
import _ from 'lodash';
import { API, BASE_URL, SEARCH_DELAY_MS } from 'CONST';
import Select from 'react-select';
import { FormGroup, Label, Col, Button } from 'reactstrap';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CheckModal from '../shared/CheckModal';
import WarningModal from '../UI/WarningModal';
import AvanzarOportunidadConfirmationModal from './AvanzarOportunidadConfirmationModal';

const CrearOportunidadSection = ({ edit, fullData, id }) => {
  const history = useHistory();
  const [sectionData, setSectionData] = useState({
    afianzado_id: null,
  });
  const [afianzadoOptions, setAfianzadoOptions] = useState([]);
  const [afianzadoSearch, setAfianzadoSearch] = useState('');
  const [defaultValue, setDefaultValue] = useState(null);
  const [showCreacionModal, setShowCreacionModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mensajeErrorModal, setMensajeErrorModal] = useState('');

  useEffect(() => {
    if (!id) {
      get(`${BASE_URL}${API.clientes}?roles__term=afianzadogarantia`).then((response) => {
        setAfianzadoOptions(
          response.results.map((e) => ({
            value: e.id,
            label: `${e.rut} - ${e.nombre}`,
          })),
        );
      });
    }
  }, []);

  const searchAfianzado = (search) => {
    const searchURL = search ? `&search=${search}` : '';
    get(`${BASE_URL}${API.clientes}?roles__term=afianzadogarantia${searchURL}`).then((response) => {
      setAfianzadoOptions(
        response.results.map((e) => ({
          value: e.id,
          label: `${e.rut} - ${e.nombre}`,
        })),
      );
    });
  };

  const searchAfianzadoDebounced = useCallback(
    _.debounce((search) => searchAfianzado(search), SEARCH_DELAY_MS),
    [],
  );

  useEffect(() => {
    if (afianzadoSearch) {
      searchAfianzadoDebounced(afianzadoSearch);
    }
  }, [afianzadoSearch]);

  useEffect(() => {
    if (edit && fullData.afianzado) {
      setDefaultValue({
        value: -1,
        label: `${fullData.afianzado.rut} - ${fullData.afianzado.nombre}`,
      });
    }
  }, [edit, fullData]);

  const crearOportunidad = () => {
    setLoading(true);
    post(`${BASE_URL}${API.oportunidadesLinea}`, sectionData)
      .then(() => {
        setShowCreacionModal(true);
      })
      .catch((error) => {
        error
          .json()
          .then((errorData) => setMensajeErrorModal(errorData.errors))
          .catch(() => setMensajeErrorModal('Ha ocurrido un error al crear la oportunidad.'));
        setShowErrorModal(true);
      })
      .finally(() => {
        setConfirmationModal(false);
        setLoading(false);
      });
  };

  return (
    <div>
      <FormGroup row>
        <Col sm={2}>
          <Label for="rut ">
            Afianzado
            <span className="required text-danger">*</span>
          </Label>
        </Col>
        <Col sm={5}>
          <Select
            options={afianzadoOptions}
            isDisabled={edit}
            value={defaultValue}
            onChange={(event) => {
              setSectionData({ afianzado_id: event.value });
              setDefaultValue(event);
            }}
            onInputChange={(event) => {
              setAfianzadoSearch(event);
            }}
            placeholder="Selecciona un afianzado"
          />
        </Col>
      </FormGroup>
      {!edit && (
        <div className="button-container d-flex justify-content-end">
          <Button
            className="btn btn-secondary blue"
            onClick={() => setConfirmationModal(true)}
            disabled={defaultValue === null || confirmationModal}
          >
            {loading ? <FontAwesomeIcon spin={loading} icon={faSpinner} /> : 'Crear Oportunidad'}
          </Button>
        </div>
      )}
      <AvanzarOportunidadConfirmationModal
        openModal={confirmationModal}
        setOpenModal={setConfirmationModal}
        avanzarOportunidad={crearOportunidad}
        mensajeModal="¿Está seguro que desea CREAR esta oportunidad?"
        loading={loading}
      />
      <CheckModal
        isOpen={showCreacionModal}
        toggle={() => history.push('/garantia/oportunidades')}
        handleOk={() => history.push('/garantia/oportunidades')}
        okBtnText="OK"
        confirmMsg="Oportunidad creada satisfactoriamente."
      />
      <WarningModal
        isOpen={showErrorModal}
        toggle={() => setShowErrorModal(false)}
        handleClearError={() => setShowErrorModal(false)}
        errorMsg={mensajeErrorModal}
        loading={false}
        onlyCancelButton
      />
    </div>
  );
};

CrearOportunidadSection.propTypes = {
  edit: PropTypes.bool.isRequired,
  fullData: PropTypes.shape({
    actualizacion_ts: PropTypes.string,
    afianzado: PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string,
      rut: PropTypes.string,
    }),
    afianzado_id: PropTypes.number,
    creacion_ts: PropTypes.string,
    estado: PropTypes.shape({
      descripcion: PropTypes.string,
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
    }),
    id: PropTypes.number,
    monto: PropTypes.number,
    responsable_id: PropTypes.number,
    suscriptor_id: PropTypes.number,
  }),
  id: PropTypes.string,
};

CrearOportunidadSection.defaultProps = {
  fullData: null,
  id: undefined,
};

export default CrearOportunidadSection;
